const statusObj = {
  ongoing: { name: 'กำลังดำเนินการ', color: '#D35C3B' },
  follow: { name: 'ติดตาม', color: '#D35C3B' },
  fixed: { name: 'แก้ไขแล้ว', color: '#228B90' }
}

export {
  statusObj
}
